import { type CombinedError, makeOperation, type Operation } from '@urql/core';
import { retryExchange } from '@urql/exchange-retry';
import {
  hasGraphQLErrorCode,
  shouldEndSessionAfterAuthRecovery,
} from '@/client/exchanges/authFailure';

export function retryWithFreshAuth(
  _error: CombinedError,
  operation: Operation,
) {
  return makeOperation(operation.kind, operation, {
    ...operation.context,
    authAttempt: false,
  });
}

export default retryExchange({
  maxNumberAttempts: 3,
  retryIf: (error) => {
    if (shouldEndSessionAfterAuthRecovery(error)) {
      return false;
    }

    return (
      !!error.networkError || hasGraphQLErrorCode(error, 'validation-failed')
    );
  },
  retryWith: retryWithFreshAuth,
});
